import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes", "className", "text", "type"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { default as withStyles } from '../styles';
import Typography from '../Typography';
import { spacing20, spacing30, borderRadiusXSmall, borderWidthThin, lineHeightReset } from '../styles/tokens';

var styles = function styles(theme) {
  return {
    // Necessary style overrides are set here
    root: {
      display: 'inline-block',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.body3.fontSize,
      padding: spacing20 + " " + spacing30,
      borderRadius: borderRadiusXSmall,
      backgroundColor: theme.palette.grey[100],
      lineHeight: lineHeightReset
    },
    default: {
      border: borderWidthThin + " solid " + theme.palette.status.default.text,
      color: theme.palette.status.default.text
    },
    draft: {
      border: borderWidthThin + " solid " + theme.palette.status.warning.text,
      color: theme.palette.status.warning.text
    },
    error: {
      border: borderWidthThin + " solid " + theme.palette.status.error.text,
      color: theme.palette.status.error.text
    },
    pending: {
      border: borderWidthThin + " solid " + theme.palette.status.neutral.text,
      color: theme.palette.status.neutral.text
    },
    success: {
      border: borderWidthThin + " solid " + theme.palette.status.success.text,
      color: theme.palette.status.success.text
    }
  };
};
/**
 * Use a `StatusLabel` to indicate the status or category of an item.
 * @done true
 * @updated v6.7.0
 * @versionAdded v0.0.10
 * @examples
 *  StatusLabelExample
 *  StatusLabelTableExample
 *  StatusLabelText
 */


var StatusLabel = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      textProp = props.text,
      typeProp = props.type,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var text = textProp.toUpperCase();
  var type = typeProp.toLowerCase();
  var classOverrides = {
    //CSS classes to override from Material UI Typography CSS API
    root: classNames(classes.root, (_classNames = {}, _classNames[classes.default] = type === 'default', _classNames[classes.draft] = type === 'draft', _classNames[classes.error] = type === 'error', _classNames[classes.pending] = type === 'pending', _classNames[classes.success] = type === 'success', _classNames), className)
  };
  return /*#__PURE__*/React.createElement(Typography, _extends({
    component: "span",
    classes: classOverrides,
    ref: ref
  }, rest), text);
});
StatusLabel.muiName = 'StatusLabel';
StatusLabel.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Text for the component to display
   */
  text: PropTypes.string.isRequired,

  /**
   * Type of status to indicate (default, draft, error, pending, success)
   */
  type: PropTypes.oneOf(['default', 'draft', 'error', 'pending', 'success'])
};
StatusLabel.displayName = 'StatusLabel';
StatusLabel.defaultProps = {
  type: 'default'
};
export default withStyles(styles)(StatusLabel);